import type { Source } from "@/apis/cs-rag/types";
import { csRagQueries } from "@/queries";
import { pushModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Trash2 } from "lucide-react";
import { DeleteSourceModal } from "./delete-source-modal";

export const SourceTable: React.FC = () => {
  const { data: sources, isLoading } = useQuery({
    ...csRagQueries.sources(),
  });

  const handleDelete = (source: Source) => {
    pushModal(DeleteSourceModal, { source });
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-10">
        <Loader2 className="size-5 animate-spin text-label-assistive" />
      </div>
    );
  }

  return (
    <table className="w-full border-collapse overflow-hidden rounded-[10px] bg-white shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
      <thead>
        <tr className="bg-background-neutral-neutral">
          <th className="px-3.5 py-2.5 text-left label-2-semibold text-label-alternative border-b border-line-alternative">
            제목
          </th>
          <th className="px-3.5 py-2.5 text-left label-2-semibold text-label-alternative border-b border-line-alternative">
            페이지
          </th>
          <th className="px-3.5 py-2.5 text-left label-2-semibold text-label-alternative border-b border-line-alternative">
            등록일
          </th>
          <th className="px-3.5 py-2.5 border-b border-line-alternative" />
        </tr>
      </thead>
      <tbody>
        {!sources?.length ? (
          <tr>
            <td
              colSpan={4}
              className="py-5 text-center body-2-normal-regular text-label-assistive"
            >
              아직 등록된 자료가 없습니다
            </td>
          </tr>
        ) : (
          sources.map((source) => (
            <tr
              key={source.id}
              className="border-b border-line-alternative last:border-b-0"
            >
              <td className="px-3.5 py-2.5 body-2-normal-regular text-label-normal">
                {source.title}
              </td>
              <td className="px-3.5 py-2.5 body-2-normal-regular text-label-normal">
                {source.page_count}
              </td>
              <td className="px-3.5 py-2.5 body-2-normal-regular text-label-alternative">
                {source.uploaded_at}
              </td>
              <td className="px-3.5 py-2.5 text-right">
                <Button
                  size={28}
                  className="!text-red-600 !border-red-200 hover:!bg-red-50"
                  onClick={() => handleDelete(source)}
                  leftIcon={<Trash2 className="size-3.5" />}
                >
                  삭제
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};
